import firebase from "./firebase";
import { SessionCache } from "./helpers/cache";

function pushNotification() {
  const messaging = firebase.messaging();
  messaging
    .requestPermission()
    .then(() => {
      return messaging.getToken();
    })
    .then((token) => {
      console.log("Token: ", token);
      const StorageCache = new SessionCache();
      StorageCache.set("push_token", token);
      // document.getElementById("token").innerHTML - token;
    })
    .catch((err) => {
      console.log(err);
    });
}

export default pushNotification;
